var lib_core = require("lib-core");
var editor_2d = require("editor-2d");

var ArcFocalHandleModel = function (type, initialCoord) {
    var self = this;
    this.makeObservableTreeNode();

    this.coord = this.value("coord", true);
    this.selected = this.value("interactionSelected",true);
    this.type = this.value("type", true); // "F" or "Fp"

    this.type(type);
    this.coord(initialCoord);
    console.assert(this.type() == "F" || this.type() == "Fp");

    this.otherHandleModel1 = null;
    this.otherHandleModel2 = null;

    this.selected.onChange("selected_infocus", function (value) {
        if (self.isAlive() && self.pathInteractionModel.isAlive()) {
            self.pathInteractionModel.infocus(value);
            self.segmentModel.infocus(value);
        }
    }, 10);

    this.onInit("initialize", this.initialize, 10);
};
lib_core.mixin(ArcFocalHandleModel, lib_core.ObservableTreeNode);
ArcFocalHandleModel.$class = "ArcFocalHandleModel";
module.exports = ArcFocalHandleModel;

ArcFocalHandleModel.prototype.initialize = function() {
    this.segmentModel = this.parent();
    this.pathInteractionModel = this.segmentModel.parent();
};

ArcFocalHandleModel.prototype.move = function (vec) {
    var self = this;
    this.segmentModel.movingHandle(true);
    var new_center = this.otherHandleModel1.coord();
    var new_focal;
    if(this.type() == "F")
        new_focal = this.coord().add(vec);
    else
        new_focal = this.otherHandleModel2.coord().sub(vec);
    self.segmentModel.setApproximateCandF(new_center, new_focal);
    this.segmentModel.movingHandle(false);
};

ArcFocalHandleModel.prototype.getSnapSet = function () {
    var self = this;
    var result = new editor_2d.SnapSet();
    result.add(self.coord(), 1);
    return result;
};

ArcFocalHandleModel.prototype.setSelected = function (selected) {
    this.selected(selected);
};

ArcFocalHandleModel.prototype.getInspectorElements = function () {
    var inspector_elements = this.parent().getInspectorElements();
    inspector_elements.help_elements['name'] = 'Arc Focal Point';
    return inspector_elements;
};
